var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_34808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8631 8.08322C15.8638 7.54476 15.8172 7.00724 15.7238 6.47656H8.09229V9.51977H12.4633C12.3738 10.0058 12.1845 10.4691 11.9067 10.8818C11.629 11.2945 11.2685 11.648 10.847 11.921V13.8964H13.4557C14.9831 12.5213 15.8631 10.4877 15.8631 8.08322Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09231 15.8034C10.2761 15.8034 12.1149 15.1032 13.4557 13.896L10.8471 11.9206C10.121 12.4013 9.18589 12.6757 8.09231 12.6757C5.98156 12.6757 4.19002 11.2863 3.54938 9.41406H0.862061V11.4498C1.5356 12.7585 2.56839 13.8586 3.84513 14.6274C5.12188 15.3962 6.59232 15.8033 8.09231 15.8034Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54949 9.41382C3.21081 8.43275 3.21081 7.37033 3.54949 6.38927V4.35352H0.862174C0.295574 5.45442 0.000488281 6.66944 0.000488281 7.90154C0.000488281 9.13364 0.295574 10.3487 0.862174 11.4496L3.54949 9.41382Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09231 3.12823C9.24634 3.10982 10.3615 3.53557 11.1966 4.31346L13.5063 2.05822C12.0417 0.715036 10.1015 -0.0223951 8.09231 0.000518417C6.59232 0.000585169 5.12188 0.407729 3.84513 1.1765C2.56839 1.94526 1.5356 3.04539 0.862061 4.35407L3.54938 6.38982C4.19002 4.51759 5.98156 3.12823 8.09231 3.12823Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_34808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.14ef90137e440cb69ab19d8089f82556.svg";
export { ForwardRef as ReactComponent };